const autoNgTemplateLoaderTemplate1 = require('./ldap-settings-dn-builder.html');

import controller from './ldap-settings-dn-builder.controller';

export const ldapSettingsDnBuilder = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    // ngModel: string (dc=,cn=,)
    ngModel: '<',
    // onChange(string) => void
    onChange: '<',
    // suffix: string (dc=,dc=,)
    suffix: '@',
    label: '@',
    limitedFeatureId: '<',
  },
};
